import { preselectService } from "@/lib/scroll";
import { useLang } from "@/i18n";
import ProductArt from "@/components/art/ProductArt";
import Icon from "@/components/Icon";
import { Reveal, Eyebrow } from "@/components/Reveal";

const CHIP_ICONS = ["sun", "zap", "battery", "home"];

export default function Solar() {
    const { t } = useLang();
    return (
        <section id="solar" data-testid="solar-section" className="relative py-24 md:py-32 lg:py-40 bg-surface overflow-hidden">
            <div className="absolute -top-40 -right-40 w-[36rem] h-[36rem] rounded-full bg-solar/10 blur-[140px] pointer-events-none" />
            <div
                className="absolute top-0 right-0 w-full h-full pointer-events-none"
                style={{ background: "radial-gradient(circle at 85% 12%, rgba(255,210,31,0.12), transparent 45%)" }}
            />
            <div className="relative max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-2 gap-14 items-center">
                <Reveal>
                    <Eyebrow color="text-solar">{t.solar.eyebrow}</Eyebrow>
                    <h2 className="font-heading text-4xl md:text-5xl font-bold tracking-tight text-ink mt-4">
                        {t.solar.headingA}<span className="text-solar">{t.solar.headingB}</span>
                    </h2>
                    <p className="mt-5 max-w-lg text-ice/60 text-base md:text-lg leading-relaxed">
                        {t.solar.sub}
                    </p>
                    <div className="mt-8 flex flex-wrap gap-3">
                        {CHIP_ICONS.map((icon, i) => (
                            <span
                                key={icon}
                                data-testid={`solar-chip-${icon}`}
                                className="flex items-center gap-2 rounded-full border border-solar/40 bg-solar/10 px-4 py-2 text-sm text-solar"
                            >
                                <Icon name={icon} size={15} />
                                {t.solar.chips[i]}
                            </span>
                        ))}
                    </div>
                    <button
                        data-testid="solar-cta"
                        onClick={() => preselectService("Solar Panel")}
                        className="mt-10 inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-cyan2 to-solar px-8 py-4 font-bold text-ink hover:shadow-[0_0_45px_rgba(201,151,0,0.35)] hover:scale-[1.03] active:scale-95 transition-all duration-300"
                    >
                        {t.solar.cta}
                        <Icon name="arrow" size={17} />
                    </button>
                </Reveal>

                <Reveal delay={0.15}>
                    <div className="relative rounded-3xl border border-solar/25 bg-white/75 p-8 overflow-hidden shadow-[0_20px_60px_rgba(13,27,46,0.08)]">
                        <div className="absolute inset-0 circuit-bg opacity-50" />
                        <div className="relative h-72 md:h-80">
                            <ProductArt type="solar" accent="#C99700" />
                            <img
                                src="/images/products/solar-panels.png"
                                alt="Solar panels — Farakka Broadband, Murshidabad"
                                loading="lazy"
                                onError={(e) => e.currentTarget.remove()}
                                className="absolute inset-0 w-full h-full object-cover rounded-2xl"
                            />
                        </div>
                        <div className="relative mt-4 flex items-center justify-between font-mono2 text-[11px] tracking-[0.2em] uppercase text-solar/80">
                            <span>{t.solar.frameLeft}</span>
                            <span className="animate-energy">{t.solar.frameRight}</span>
                        </div>
                    </div>
                </Reveal>
            </div>
        </section>
    );
}
